"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Utility for drag and drop API
 */
ngModule.factory("fileDropUtils", function () {
  return {
    /**
     * Returns true if array contains any of given items, false otherwise.
     * @param el
     * @param scope
     * @param onEnter
     * @param onLeave
     */
    addFileDragEvents: function addFileDragEvents(el, scope, onEnter, onLeave) {
      var dragging = false;
      var leaving = false;
      var timeout = null;
      var onDragEnter = function onDragEnter() {
        if (onEnter) {
          scope.$apply(function () {
            return onEnter(el);
          });
        }
      };
      var onDragLeave = function onDragLeave() {
        if (onLeave) {
          scope.$apply(function () {
            return onLeave(el);
          });
        }
      };
      el.on('dragenter.filedrop', function () {
        leaving = false;
        if (!dragging) {
          dragging = true;
          onDragEnter();
        }
      });
      el.on('dragover.filedrop', function () {
        leaving = false;
        if (!dragging) {
          dragging = true;
          onDragEnter();
        }
      });
      el.on('dragleave.filedrop', function () {
        leaving = true;
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          if (leaving) {
            dragging = false;
            onDragLeave();
          }
        }, 100);
      });
      el.on('drop.filedrop', function () {
        leaving = true;
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          if (leaving) {
            dragging = false;
            onDragLeave();
          }
        }, 100);
      });
      return function () {
        el.off('.filedrop');
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/fileDropUtils.js
// module id = 2753
// module chunks = 13